function ProjectForm({
  projectName,
  setProjectName,
  projectFocusAreaId,
  setProjectFocusAreaId,
  projectStatusId,
  setProjectStatusId,
  projectNotes,
  setProjectNotes,
  focusAreas,
  statusLevels,
  editingProjectId,
  saveProject,
  clearProjectForm
}) {

  return (
    <>
      <div className="season-form-grid">
        <input
          placeholder="Project name"
          value={projectName}
          onChange={(e) => setProjectName(e.target.value)}
        />

        <select
          value={projectFocusAreaId}
          onChange={(e) =>
            setProjectFocusAreaId(e.target.value)
          }
        >
          <option value="">Focus Area</option>

          {focusAreas?.map(area => (
            <option key={area.id} value={area.id}>
              {area.name}
            </option>
          ))}
        </select>

        <select
          value={projectStatusId}
          onChange={(e) =>
            setProjectStatusId(e.target.value)
          }
        >
          <option value="">Status</option>

          {statusLevels?.map(status => (
            <option key={status.id} value={status.id}>
              {status.name}
            </option>
          ))}
        </select>
      </div>

      <textarea
        className="season-notes"
        placeholder="Notes, vision, next steps..."
        value={projectNotes}
        onChange={(e) =>
          setProjectNotes(e.target.value)
        }
      />

      <div className="season-form-actions">
        <button onClick={saveProject}>
          {editingProjectId
            ? 'Update Project'
            : 'Save Project'}
        </button>

        {editingProjectId && (
          <button
            onClick={clearProjectForm}
            style={{ background: '#666' }}
          >
            Cancel Edit
          </button>
        )}
      </div>
    </>
  )
}

export default ProjectForm
